const checkStatus = {
  PENDING: 'pending',
  DISMISSED: 'dismissed',
  COMPLETED: 'completed',
} as const

export type CheckStatus = typeof checkStatus[keyof typeof checkStatus]

const progressStatus = {
  NONE: 'none',
  STARTED: 'started',
  DONE: 'done',
} as const

export type ProgressStatus = typeof progressStatus[keyof typeof progressStatus]

const baseAssistantOverviewUrl = 'https://assistant.getsilverfin.com/outliers?'

export { checkStatus, progressStatus, baseAssistantOverviewUrl }
